module.exports = __webpack_public_path__ + "static/akv2k8s-b749ec5f4bfd805a88626e0fd2b9ba82.png";